module.exports = __webpack_public_path__ + "img/img26.170086a8.jpg";